import React from "react";
import DownloadIcon from "@mui/icons-material/Download";
import OpenInBrowserIcon from "@mui/icons-material/OpenInBrowser";

const FILE_OBJECT_REVOKE_DELAY_MS = 1000;
const EMPTY_PREVIEW_TEXT = "No text content";

const getPlainTextPreview = (content = "") => {
  const parsedDocument = new DOMParser().parseFromString(content, "text/html");
  return parsedDocument.body.textContent?.trim() || EMPTY_PREVIEW_TEXT;
};

const downloadReceivedFile = (file) => {
  if (!file) return;

  const objectUrl = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = file.name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), FILE_OBJECT_REVOKE_DELAY_MS);
};

const ReceivedTransferPreview = ({ receivedTransfer, onClose, onOpen }) => {
  const { title, content, file } = receivedTransfer;
  const previewText = getPlainTextPreview(content);

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-md border border-border bg-surface-muted p-3">
        <p className="text-xs font-semibold uppercase text-text-muted">Received note</p>
        <h3 className="mt-1 text-lg font-bold text-text">
          {title || "Untitled local note"}
        </h3>
        <p className="mt-2 max-h-28 overflow-auto text-sm text-text">
          {previewText}
        </p>
      </div>

      {file && (
        <div className="rounded-md border border-border bg-surface p-3 text-sm text-text">
          File received: <span className="font-semibold">{file.name}</span>
        </div>
      )}

      <div className="flex flex-wrap gap-2">
        <button
          className="inline-flex items-center gap-2 rounded-md bg-primary px-3 py-2 text-sm font-semibold text-on-primary hover:bg-primary-hover"
          onClick={() => onOpen(receivedTransfer)}
          type="button"
        >
          <OpenInBrowserIcon fontSize="small" />
          Open in editor
        </button>
        {file && (
          <button
            className="inline-flex items-center gap-2 rounded-md border border-border px-3 py-2 text-sm font-semibold text-text hover:bg-surface-muted"
            onClick={() => downloadReceivedFile(file)}
            type="button"
          >
            <DownloadIcon fontSize="small" />
            Download file
          </button>
        )}
        <button
          className="rounded-md border border-border px-3 py-2 text-sm font-semibold text-text hover:bg-surface-muted"
          onClick={onClose}
          type="button"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ReceivedTransferPreview;
